import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText
} from '@mui/material'
import { AmlQuestion } from 'api/compliance'
import { useFormikContext } from 'formik'
import { FormValues } from '../OnboardingWizard'
import {
  commentsRequired,
  selectedOptions,
  toggleMultiOption
} from './amlOptionUtils'
import CommentFormField from './CommentFormField'

interface MultiSelectQuestionProps {
  question: AmlQuestion
}

// Checkbox group bound to the REST answer_options. The form value is stored
// as the canonical option texts joined with ', ' — the exact string the
// backend multi-select matcher splits on, and the same shape prior_answer
// arrives in, so seeding works unchanged.
export default function MultiSelectQuestion({
  question
}: MultiSelectQuestionProps) {
  const { values, errors, setFieldValue, isSubmitting } =
    useFormikContext<FormValues>()

  const raw = values[question.key]
  const selected = selectedOptions(question, raw).map(option => option.answer)
  const error = errors[question.key]

  return (
    <FormControl component='fieldset' error={!!error} fullWidth>
      <FormGroup>
        {(question.answer_options ?? []).map(option => (
          <FormControlLabel
            key={option.answer}
            control={
              <Checkbox
                checked={selected.includes(option.answer)}
                disabled={isSubmitting}
                onChange={(_, checked) =>
                  setFieldValue(
                    question.key,
                    toggleMultiOption(question, raw, option.answer, checked)
                  )
                }
              />
            }
            label={option.answer}
            sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
          />
        ))}
      </FormGroup>
      {commentsRequired(question, raw) && (
        <CommentFormField questionKey={question.key} />
      )}
      {error && <FormHelperText>{String(error)}</FormHelperText>}
    </FormControl>
  )
}
